import { EditorMode } from "./EditorMode";
export class EditorSettings {
    constructor() {
        this.currentMode = EditorMode.RESEARCH;
        this.currentTabs = {
            RESEARCH: {
                leftTab: 0,
                rightTab: 0
            },
            COPY: {
                leftTab: 0,
                rightTab: 0
            },
            WRITING: {
                leftTab: 0,
                rightTab: 0
            }
        };
    }
}
